import React, { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AuthContext from '../context/AuthContext';

const RoleBasedRoute = ({ allowedRoles }) => {
  const { user } = useContext(AuthContext);

  const isAllowed = user && allowedRoles.includes(user.role);

  return isAllowed ? <Outlet /> : <Navigate to="/" replace />;
};

export default RoleBasedRoute;